import './seeall.scss';

export const SeeAll = () => {
	const handleNavigateToSeeAll = () => {
		globalThis.location.href = `${globalThis.location.origin}/products?attributes=event`;
	};
	return (
		<div className='seeaAllMainContainer'>
			<div className='seeAllContainer'>
				<p onClick={handleNavigateToSeeAll} className='seeall'>
					See all products at Newtopia Now
					<i className='ri-arrow-right-line'></i>
				</p>
			</div>
		</div>
	);
};
